import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Vegetables = lazyWithPreload(() => import('./Vegetables'))
export const LikeChatVegetables = lazyWithPreload(
  () => import('./LikeChatVegetables'),
)
